import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const ALLOWED_ROLES = ['staff', 'readonly_admin', 'admin', 'superadmin']

export default function AdminRoute() {
  const { user, profile, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-8 h-8 border-4 border-oasis-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  // profile may still be loading briefly after user is set
  if (profile && !ALLOWED_ROLES.includes(profile.role)) return <Navigate to="/" replace />

  // Still fetching profile — spinner prevents a premature redirect
  if (!profile) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-8 h-8 border-4 border-oasis-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return <Outlet />
}
